import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnBuyStep_12 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_12 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_12) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_11);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_13);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="buy"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_12;
